import { EquipmentRef } from '@core/referential/equipment-ref.enum'

// Declaration order = display order on the GTB "Alarmes et défauts" page.
export enum AlarmCategory {
  HEATING_COOLING_CIRCUIT = 'heatingCoolingCircuit',
  BOILER = 'boiler',
  HOT_WATER = 'hotWater',
  CTA = 'cta',
  ELECTRICAL_BOARD = 'electricalBoard',
  MEDICAL_FLUID = 'medicalFluid',
  CHILLER = 'chiller',
  HEAT_PUMP = 'heatPump',
  VRV = 'vrv',
  BATTERY = 'battery',
  OTHER = 'other',
}

// Nature of a macro (parent) equipment, keyed by its equipment_ref name. Every
// ongoing energy alert of a child point is attached to its parent, and the
// parent's ref decides the display category — the mapping classifies parents,
// it never filters alarms. zoneTemperature and zoneLight are intentionally
// absent: their category cannot be read off the parent (VRV metadata for the
// former, the children's own refs for the latter), see getAlarmCategory and
// ALARM_CATEGORY_BY_POINT_REF below.
export const ALARM_CATEGORY_BY_PARENT_REF: Partial<Record<EquipmentRef, AlarmCategory>> = {
  [EquipmentRef.DISTRIBUTION_HEATING]: AlarmCategory.HEATING_COOLING_CIRCUIT,
  [EquipmentRef.DISTRIBUTION_CONSTANT]: AlarmCategory.HEATING_COOLING_CIRCUIT,
  [EquipmentRef.DISTRIBUTION_CONSTANT_HEATING]: AlarmCategory.HEATING_COOLING_CIRCUIT,
  [EquipmentRef.DISTRIBUTION_COLD]: AlarmCategory.HEATING_COOLING_CIRCUIT,
  [EquipmentRef.DISTRIBUTION_CHANGEOVER]: AlarmCategory.HEATING_COOLING_CIRCUIT,
  [EquipmentRef.DISTRIBUTION_CONSTANT_COLD]: AlarmCategory.HEATING_COOLING_CIRCUIT,
  [EquipmentRef.DISTRIBUTION_CONSTANT_CHANGEOVER]: AlarmCategory.HEATING_COOLING_CIRCUIT,
  [EquipmentRef.HEATING_BOILER]: AlarmCategory.BOILER,
  [EquipmentRef.PRODUCTION_HEATING]: AlarmCategory.BOILER,
  [EquipmentRef.HOT_WATER]: AlarmCategory.HOT_WATER,
  [EquipmentRef.ZONE_CTA]: AlarmCategory.CTA,
  [EquipmentRef.CHILLER_UNIT]: AlarmCategory.CHILLER,
  [EquipmentRef.PRODUCTION_COOLING]: AlarmCategory.CHILLER,
  [EquipmentRef.HEAT_PUMP]: AlarmCategory.HEAT_PUMP,
  [EquipmentRef.PRODUCTION_HEAT_PUMP_CHILLER]: AlarmCategory.HEAT_PUMP,
}

// Categories carried by the POINT rather than by its parent. Two situations need
// this: `zoneLight` is overloaded (it parents electrical boards AND medical fluid
// manifolds alike, so the parent ref says nothing), and battery health belongs to
// its own category whatever the parent is.
//
// A point listed here is grouped under its own category instead of its parent's:
// the endpoints key their macro buckets on this value, so a macro relaying two
// families yields one card per family. Adding a family is one line here — no new
// flag, no new branch.
export const ALARM_CATEGORY_BY_POINT_REF: Partial<Record<EquipmentRef, AlarmCategory>> = {
  [EquipmentRef.DEFAULT_ELEC]: AlarmCategory.ELECTRICAL_BOARD,
  [EquipmentRef.REVERSE_DEFAULT_ELEC]: AlarmCategory.ELECTRICAL_BOARD,
  [EquipmentRef.MEDICAL_FLUID_DEFAULT]: AlarmCategory.MEDICAL_FLUID,
  [EquipmentRef.REVERSE_MEDICAL_FLUID_DEFAULT]: AlarmCategory.MEDICAL_FLUID,
  [EquipmentRef.DEFAULT_BATTERY]: AlarmCategory.BATTERY,
}
